import React from 'react'
import { Box, Typography } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'

export default function JoinQRCode({ code, size = 200 }) {
  const joinUrl = `${window.location.origin}/event-quiz/join/${code}`

  return (
    <Box sx={{ textAlign: 'center' }}>
      <QRCodeSVG value={joinUrl} size={size} level="H" includeMargin />
      <Typography variant="h3" fontWeight="bold" letterSpacing={4} sx={{ mt: 2 }}>
        {code}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Scannez pour rejoindre
      </Typography>
    </Box>
  )
}
